import http from "../http-common";

class SimpleUploadService {
    upload(file, token, route, onUploadProgress) {
        let formData = new FormData();

        formData.append("file", file);

        return http.post(route, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + token,
            },
            onUploadProgress
        });
    }
}

export default new SimpleUploadService();
